import React from 'react'
import { Box, Button, CircularProgress } from '@material-ui/core'
import { Info, Check as CheckIcon } from '@material-ui/icons'
import { green } from '@material-ui/core/colors'

const AnnotateButton = ({ onClick, status }) => {
  const buttonSx = {
    ...(status === 'success' && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Button
        variant="contained"
        color="info"
        onClick={onClick}
        disabled={status === 'loading' || status === 'success'}
        sx={buttonSx}
        size="small"
      >
        {status === 'success' ? <CheckIcon /> : <Info />}
      </Button>
      {status === 'loading' && (
        <CircularProgress
          size={24}
          sx={{
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  )
}

export default AnnotateButton
